import Lenis from 'lenis'

const lenis = new Lenis({
  touchMultiplier:0,
   anchors: {
    offset:-85,
    easing:(t) =>Math.min(1, 1.001 - Math.pow(2, -10 * t))
   }
});
// default start
lenis.start();
// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

export default lenis;